import React, { Component } from 'react';
import PropType from 'prop-types';
import { Analytics } from 'packages';
import { DialogModal } from 'components';
import { getReturnUrl } from 'static/script/utils/login';
import { loadModule, handleError } from 'utils/code-split';
import uiActions from 'state/actions/ui';
import STRINGS from 'constants/strings';
import Close from '@tradera/tradera-ui/icons/close.svg?jsx';
import TraderaLoginBackground from './tradera_login_img.jpg';
import TraderaLoginLogo from './tradera_logo_white.png';
import './sign-in-modal.scss';
// import image from 'static/images/login/loginimg.png';
// import videoMP4 from 'static/videos/tradera_login_video.mp4';
// import videoWEBM from 'static/videos/tradera_login_video.webm';

const onIframeLoad = (e, handleLoginClick) => {
    const iframe = e.target;
    if (iframe) {
        const iframeDocument =
            iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDocument) {
            iframeDocument.body.addEventListener('keydown', e => {
                if (e.keyCode === 27) {
                    handleLoginClick();
                }
            });
        }
    }
};

class SignInModal extends Component {
    static propTypes = {
        handleLoginClick: PropType.func,
        dispatch: PropType.func
    };

    static defaultProps = {
        redirectURL: false
    };

    componentDidMount = async () => {
        try {
            const module = await import(/* webpackChunkName: "humany" */ '../humany/humany');
            await loadModule(module, this.props.initData);
        } catch (error) {
            handleError(error);
        }
    };

    componentWillUnmount() {
        Analytics.trackEvent({
            category: 'Header',
            action: 'Navigation',
            label: `Login Anywhere - close`
        });
    }

    handleCloseClick = () => this.props.dispatch(uiActions.closeSignInModal());

    render() {
        const { handleLoginClick, redirectURL } = this.props;
        return (
            <DialogModal
                onDismiss={() => this.handleCloseClick()}
                className="sign-in-modal"
                desktop>
                <div className="sign-in-modal-body d-flex">
                    <div className="d-lg-flex d-none position-relative">
                        <img
                            src={TraderaLoginBackground}
                            alt={STRINGS.WELCOME_TO_TRADERA}
                        />
                        <div className="d-flex position-absolute h-100 flex-column align-items-center signin-modal signin-intro">
                            <div className="col-8 text-center my-4 py-4">
                                <img src={TraderaLoginLogo} />
                            </div>
                            <div className="col-8">
                                <h3 className="with-asap signin-modal signin-introtext text-center">
                                    {STRINGS.WELCOME_TO_TRADERA}
                                </h3>
                            </div>
                        </div>
                        {/*<video
                                className="h-100"
                                id="landing-video"
                                poster={image}
                                autoPlay
                                loop>
                                <source src={videoWEBM} type="video/webm" />
                                <source src={videoMP4} type="video/mp4" />
                                <img src={image} />
                            </video>*/}
                    </div>
                    <div className="d-flex w-100 sign-in-modal-wrapper">
                        <iframe
                            src={`${window.location.origin}/login${getReturnUrl(
                                redirectURL
                            )}&login-modal=true`}
                            id="sign-in-modal"
                            title="Login"
                            onLoad={e => onIframeLoad(e, handleLoginClick)}>
                            <p>{STRINGS.IFRAME_NOT_SUPPORTED}</p>
                        </iframe>
                    </div>
                    <span
                        className="close-button p-3"
                        onClick={e => {
                            this.handleCloseClick();
                            e.stopPropagation();
                        }}>
                        <Close className="icon icon-dark" />
                    </span>
                </div>
            </DialogModal>
        );
    }
}

export default SignInModal;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/sign-in-modal/sign-in-modal.jsx